var _defs, _rect, _circle, _circle2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path, _path2, _path3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryCastle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 820,
    height: 420,
    viewBox: "0 0 820 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9c6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffecc7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stone",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f1f5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dfe7ff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 420,
    fill: "url(#sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 90,
    r: 36,
    fill: "#ffe27a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 70,
    r: 14,
    fill: "#fff3c2",
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 210,
    width: 540,
    height: 160,
    rx: 20,
    fill: "url(#stone)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 150,
    width: 130,
    height: 220,
    rx: 18,
    fill: "url(#stone)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 150,
    width: 130,
    height: 220,
    rx: 18,
    fill: "url(#stone)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 110,
    width: 70,
    height: 80,
    rx: 12,
    fill: "#cbd9ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 110,
    width: 70,
    height: 80,
    rx: 12,
    fill: "#cbd9ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 80,
    width: 160,
    height: 290,
    rx: 20,
    fill: "url(#stone)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 200,
    width: 70,
    height: 120,
    rx: 16,
    fill: "#f6c5a5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 190,
    width: 96,
    height: 20,
    rx: 10,
    fill: "#e2a684"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 260,
    width: 40,
    height: 60,
    rx: 10,
    fill: "#c6d7ff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 260,
    width: 40,
    height: 60,
    rx: 10,
    fill: "#c6d7ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 350,
    width: 580,
    height: 30,
    rx: 15,
    fill: "#ffd9a8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 150 L275 110 L290 150 Z",
    fill: "#f7a3b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520 150 L535 110 L550 150 Z",
    fill: "#f7a3b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380 80 L410 40 L440 80 Z",
    fill: "#f7a3b9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 45,
    r: 8,
    fill: "#ffe27a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryCastle);
export default __webpack_public_path__ + "static/media/story-castle.17438266433d255c0b8780ae48c6d41f.svg";
export { ForwardRef as ReactComponent };